import { CreatePartnerLeadRequestSchema, CreatePartnerLeadResponseSchema } from './create-partner-lead.schema';
/**
 * Create Partner Lead Endpoint Contract
 * Creates a lead for the authenticated partner by handing it to the existing
 * n8n intake pipeline (which creates the HubSpot contact + partner association
 * and runs enrichment). The partner is resolved server-side from the JWT.
 */ export const createPartnerLeadContract = {
    method: 'POST',
    path: '/api/v2/partner/leads',
    description: 'Creates a lead for the authenticated partner via the n8n intake',
    requestSchema: CreatePartnerLeadRequestSchema,
    responseSchema: CreatePartnerLeadResponseSchema,
    statusCodes: {
        success: 201,
        errors: {
            400: 'Invalid request body or lead not positively qualified',
            401: 'Unauthorized - invalid or missing token',
            403: 'Forbidden - tenant is not a partner or has no hubspotPartnerCompanyId',
            502: 'Bad Gateway - the n8n intake webhook failed',
            503: 'Service Unavailable - the intake webhook is not configured'
        }
    }
};

//# sourceMappingURL=create-partner-lead.contract.js.map